import React from 'react';
import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import banner1 from '../images/newbanner.jpg';
import banner2 from '../images/newbanner2.png';
import banner3 from '../images/newbanner3.png';

const Carousal = () => {
  return (
    <>
      <style>
        {`
          /* Full Width Banner Carousel */
          .glamour-carousel {
            position: relative;
            width: 100%;
            background-color: #f8f9fa;
            overflow: hidden;
          }
          
          .glamour-carousel .carousel {
            width: 100%;
            margin: 0;
            padding: 0;
          }
          
          .glamour-carousel .carousel-inner {
            overflow: hidden;
          }
          
          /* Full Width Carousel Item */
          .glamour-carousel .carousel-item {
            position: relative;
            width: 100%;
            background-color: #f8f9fa;
          }
          
          /* Full Width Image Wrapper - Banner Section */
          .glamour-carousel .carousel-image-wrapper {
            position: relative;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #f8f9fa;
          }
          
          .glamour-carousel .carousel-image-wrapper img {
            width: 100%;
            height: auto; /* Changed from max-height to auto */
            object-fit: contain; /* Changed from cover to contain for full view */
            display: block;
            transition: opacity 0.8s ease-in-out;
          }
          
          /* Content Section - Below Banner (70px height) */
          .carousel-text-section {
            width: 100%;
            height: 70px;
            background: linear-gradient(135deg, #ffffff, #f0f0f0);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 30px;
            border-top: 2px solid #e9ecef;
            gap: 20px;
          }
          
          .content-title {
            font-size: 1.4rem;
            font-weight: 700;
            color: #333;
            margin: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 250px;
          }
          
          .content-description {
            font-size: 1.3rem;
            line-height: 1.4;
            color: black;
            margin: 0;
            flex: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          
          .content-description b {
            color: #ff6b6b;
          }
          
          .content-button {
            display: inline-block;
            padding: 8px 20px;
            background: linear-gradient(90deg, #ff6b6b, #4ecdc4);
            color: white;
            text-decoration: none;
            border-radius: 50px;
            font-weight: 600;
            font-size: 0.85rem;
            transition: all 0.3s ease;
            border: none;
            cursor: pointer;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
            text-align: center;
            white-space: nowrap;
            flex-shrink: 0;
          }
          
          .content-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 15px rgba(0,0,0,0.2);
            background: linear-gradient(90deg, #ff5252, #3ebdb4);
            color: white;
            text-decoration: none;
          }
          
          /* Hide Previous/Next Buttons */
          .glamour-carousel .carousel-control-prev,
          .glamour-carousel .carousel-control-next {
            display: none !important;
          }
          
          /* Custom Indicators */
          .glamour-carousel .carousel-indicators {
            bottom: 80px;
            z-index: 10;
            gap: 10px;
          }
          
          .glamour-carousel .carousel-indicators button {
            width: 35px;
            height: 4px;
            background: rgba(0, 0, 0, 0.3);
            border: none;
            border-radius: 3px;
            transition: all 0.3s ease;
          }
          
          .glamour-carousel .carousel-indicators button.active {
            width: 55px;
            background: #ff6b6b;
          }
          
          .glamour-carousel .carousel-indicators button:hover {
            background: rgba(0, 0, 0, 0.5);
          }
          
          /* Responsive Design */
          @media (max-width: 1024px) {
            .glamour-carousel .carousel-image-wrapper img {
              height: auto; /* Keep auto height */
            }
            
            .carousel-text-section {
              padding: 0 20px;
              gap: 15px;
            }
            
            .content-title {
              font-size: 1rem;
              max-width: 200px;
            }
            
            .content-description {
              font-size: 0.85rem;
            }
          }
          
          @media (max-width: 768px) {
            .glamour-carousel .carousel-image-wrapper img {
              height: auto; /* Keep auto height */
            }
            
            .carousel-text-section {
              height: auto;
              min-height: 70px;
              padding: 12px 15px;
              flex-wrap: wrap;
              gap: 10px;
              justify-content: center;
              text-align: center;
            }
            
            .content-title {
              font-size: 1rem;
              max-width: none;
              white-space: normal;
            }
            
            .content-description {
              font-size: 0.8rem;
              white-space: normal;
              flex: none;
              width: 100%;
              text-align: center;
            }
            
            .content-button {
              padding: 7px 18px;
              font-size: 0.8rem;
            }
            
            .glamour-carousel .carousel-indicators {
              bottom: 85px;
            }
          }
          
          @media (max-width: 480px) {
            .glamour-carousel .carousel-image-wrapper img {
              height: auto; /* Keep auto height */
            }
            
            .carousel-text-section {
              min-height: 60px;
              padding: 10px 10px;
            }
            
            .content-title {
              font-size: 0.9rem;
            }
            
            .content-description {
              font-size: 0.75rem;
              line-height: 1.3;
            }
            
            .content-button {
              padding: 6px 15px;
              font-size: 0.75rem;
            }
            
            .glamour-carousel .carousel-indicators {
              bottom: 70px;
            }
          }
        `}
      </style>

      <div className="glamour-carousel">
        <Carousel
          fade={true}
          interval={4000}
          controls={false}
          indicators={true}
          pause={false}
          ride="carousel"
          touch={true}
        >
          {/* First Slide */}
          <Carousel.Item>
            <div className="carousel-image-wrapper">
              <img src={banner1} alt="Welcome to Agency Bazaar" />
            </div>
            <div className="carousel-text-section">
              <h2 className="content-title">Welcome to Agency Bazaar</h2>
              <p className="content-description">
                <b>Aspire to be the master of your own destiny.</b> Join us on an incredible journey of growth, success, and financial independence.
              </p>
            </div>
          </Carousel.Item>

          <Carousel.Item>
            <div className="carousel-image-wrapper">
              <img src={banner2} alt="Welcome to Agency Bazaar" />
            </div>
            <div className="carousel-text-section">
              <h2 className="content-title">Welcome to Agency Bazaar</h2>
              <p className="content-description">
                <b>Aspire to be the master of your own destiny.</b> Join us on an incredible journey of growth, success, and financial independence.
              </p>

            </div>
          </Carousel.Item>

          {/* Second Slide */}
          <Carousel.Item>
            <div className="carousel-image-wrapper">
              <img src={banner3} alt="Empower Your Future" />
            </div>
            <div className="carousel-text-section">
              <h2 className="content-title">Empower Your Future</h2>
              <p className="content-description">
                Take control of your career and build financial freedom. Get the tools, training, and support you need to succeed.
              </p>
            </div>
          </Carousel.Item>
        </Carousel>
      </div>
    </>
  );
};

export default Carousal;


